// HeaderWidget.js
// A static text band used to section a dashboard ("Q3 Renewals", "Compliance").
// It binds to no function and no run, so it is the one widget that renders
// without an instance.

import React from 'react';
import { Box, Typography } from '@mui/material';

function HeaderWidget({ config = {} }) {
  const text = typeof config.text === 'string' ? config.text.trim() : '';
  const subtitle = typeof config.subtitle === 'string' ? config.subtitle.trim() : '';

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: 0 }}>
      {/* An empty header would otherwise be an invisible card the user cannot
          find again to edit, so it always shows something. */}
      <Typography variant="h6" color={text ? 'text.primary' : 'text.disabled'}>
        {text || 'Header'}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export default HeaderWidget;
